module.exports = __webpack_public_path__ + "img/4b3ad8ab2ecf5d87293a9c7140a338ae.png";